module.exports = __webpack_public_path__ + "static/img/haqcs.6bb48c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/offer/haqcs.png
// module id = 52
// module chunks = 1 2